// extracted by mini-css-extract-plugin
export var videoWrapper = "youtube-module--video-wrapper--SEF4E";